import {
  CHECK_BOX_VALUE,
  CUSTOMERS,
  ERP_SALES_ORDER,
  GRID_ROWS_PER_PAGE,
  SWITCH_VALUE,
} from '../../../constants';

export const initialState = {
  importStartDate: null,
  importToDate: null,
  globalCustomerNumber: '',
  globalCustomerModalGridData: [],
  parentGlobalGridTotalRecords: 0,
  accountingGroup: '',
  orderGroup: ERP_SALES_ORDER.ANY_VALUE,
  ncrSiteId: 0,
  psSiteCode: 0,
  shipStartDate: null,
  shipToDate: null,
  allSalesOrderItemsMustQuality: true,
  importStatus: 3,
  importStatus2: '<>',
  mappingType: ERP_SALES_ORDER.ANY_VALUE,
  importStatusListData: [],
  mappingTypeData: [],
  isSitesResultsFound: false, // variable for result found here
  erpOrderSearchData: [],
  selectSingleRow: [],
  displayButtonValue: '',
  billToCustomeGridData: [],
  orderNumberSearch: 0,
  erpFastFindDataFound: false,
  callSearch: false,
  erpSalesOrderLoading: false,
  customerGridDataFound: true,
  globalCustLoad: false,
  siteType: [],
  loading: false,
  customerModal: false,
  billCustomerModal: false,
  //Modals
  accountingGroupModal: {
    //Accounting Group
    openAccountingGroupModal: false, // You can store AccountingGrouo modal open status here
    accountingGroupSearchData: [], // You can store the AccountingGrouo search data here
    gridAccountingRowSelectedData: [], // You can store the grid row selected data here
    gridAccountingRowSelectedCount: 0, // You can store the grid rows selected count
    accountingGroups: [], // You can store the accounting groups here
    accountingGroupGridTotalRecords: 0, // You can store the total records of the grid here
    accountingGroupSearchForm: {
      accountingGroupCode: '',
      isActive: SWITCH_VALUE.yes,
      isResellerGroup: SWITCH_VALUE.no,
    },
  },
  parentGlobalModal: {
    openParentGlobalCustomerNoModal: false, // You can store ParentGlobalCustomerNo modal open status here
    gridParentGlobalCustomerNoRowSelectedData: [], // You can store the grid row selected data here
    gridParentGlobalGridRowSelectedCount: 0,
    parentGlobalGridTotalRecords: 0,
    parentGlobalGridData: [],
    errorModal: null,
    customerNameSearchTerm: '',
    showCustomernameSelectedValue: null,
    name: [],
    isParentGlobalResultsFound: true,

    parentGlobalModalMultipleInputs: {
      name: '',
      accountingGroup: '',
      parentPsCustomerCode: '',
      activeFlag: '',
      corporateCustomer: '',
      billtoCustomer: '',
      pageIndex: 0,
      recordCount: GRID_ROWS_PER_PAGE.customers,
    },
    parentGlobalModalDropDownValues: {
      activeFlag: CUSTOMERS.dropDownDefaultValueForAny,
      corporateCustomer: CUSTOMERS.dropDownDefaultValueForAny,
      billtoCustomer: CUSTOMERS.dropDownDefaultValueForAny,
    },
  },
  //Modals
  siteSearchModal: {
    //Site
    openSiteModal: false, // You can store Site modal open status here
    siteSearchData: [], // You can store the Sitesearch data here
    gridSiteRowSelectedData: [], // You can store the grid row selected data here
    gridSiteRowSelectedCount: 0, // You can store the grid rows selected count
    sites: [], // You can store the accounting groups here
    siteGridTotalRecords: 0, // You can store the total records of the grid here
    siteSearchForm: {
      active: 'y',
      billToCustomer: 0,
      corporateCustomer: 0,
      name: '',
      pageIndex: 0,
      recordCount: 0,
      siteNumber: '',
      siteType: 0,
      ps_Customer_code: 0,
      bill_ps_Cutomer_code: 0,
    },
  },
  getSiteData: '',

  requestBody: {
    dates: {
      shipFromDate: '',
      shipToDate: '',
      firstModifiedFromTimestamp: '',
      firstModifiedToTimestamp: '',
      effectiveFromDate: '',
      effectiveToDate: '',
      endOfServiceFromDate: '',
      endOfServiceToDate: '',
    },
    entitlementTypeId: 0,
    entitlementStatusId: 0,
    customerId: 0,
    vci: 0,
    siteId: 0,
    vsi: 0,
    erpServiceProductId: 0,
    oldRSIMProductId: 0,
    warrantyPartNumber: 0,
    serialNumber: '',
    orderNumber: '',
    contractId: 0,
    contractHistoryTypeId: 0,
    recordCount: 0,
    pageIndex: 0,
  },

  //Modals
  erpSalesSearchModal: {
    //Accounting Group
    openAccountingGroupModal: false, // You can store AccountingGrouo modal open status here
    accountingGroupSearchData: [], // You can store the AccountingGrouo search data here
    gridAccountingRowSelectedData: [], // You can store the grid row selected data here
    gridAccountingRowSelectedCount: 0, // You can store the grid rows selected count
    accountingGroups: [], // You can store the accounting groups here
    accountingGroupGridTotalRecords: 0, // You can store the total records of the grid here
    accountingGroupSearchForm: {
      accountingGroupCode: '',
      isActive: SWITCH_VALUE.yes,
      isResellerGroup: SWITCH_VALUE.blank,
    },
    //Country
    openCountryModal: false, // You can store Country modal open status here
    countrySearchData: [], // You can store the AccountingGrouo search data here
    gridCountryRowSelectedData: [], // You can store the grid row selected data here
    gridCountryRowSelectedCount: 0, // You can store the grid rows selected count
    countries: [], // You can store the accounting groups here
    countryGridTotalRecords: 0, // You can store the total records of the grid here
    countrySearchForm: {
      name: '',
      countryCode: '',
    },
    //Customer
    openCustomerModal: false, // You can store Customer modal open status here
    customerSearchData: [], // You can store the Customersearch data here
    gridCustomerRowSelectedData: [], // You can store the grid row selected data here
    gridCustomerRowSelectedCount: 0, // You can store the grid rows selected count
    customers: [], // You can store the customers here
    customerGridTotalRecords: 0, // You can store the total records of the grid here
    customerSearchForm: {
      name: '',
      customerId: '',
    },
    //BillTo
    openBillToModal: false, // You can store BillTo modal open status here
    billToSearchData: [], // You can store the BillTosearch data here
    gridBillToRowSelectedData: [], // You can store the grid row selected data here
    gridBillToRowSelectedCount: 0, // You can store the grid rows selected count
    billTos: [], // You can store the billtos here
    billToGridTotalRecords: 0, // You can store the total records of the grid here
    billToSearchForm: {
      name: '',
      billToId: '',
    },
    //Site
    openSiteModal: false, // You can store Site modal open status here
    siteSearchData: [], // You can store the Sitesearch data here
    gridSiteRowSelectedData: [], // You can store the grid row selected data here
    gridSiteRowSelectedCount: 0, // You can store the grid rows selected count
    sites: [], // You can store the accounting groups here
    siteGridTotalRecords: 0, // You can store the total records of the grid here
    siteSearchForm: {
      name: '',
      siteId: '',
    },
  },
  //Search Data
  contractsSearch: {
    shortName: '',
    accountingGroupCode: '',
    accountingGroupName: ERP_SALES_ORDER.inputModalDefaultVal,
    countryId: 0,
    countryName: '',
    customerId: 0,
    customerName: '',
    billToId: 0,
    billToName: '',
    siteId: 0,
    siteName: '',
    statusId: 0,
    levelId: 0,
    isNoCountryCheck: CHECK_BOX_VALUE.no, // You can store the no country check here
    isNoCustomerCheck: CHECK_BOX_VALUE.no, // You can store the no customer check here
    isNoBillToCheck: CHECK_BOX_VALUE.no, // You can store the no bill to check here
    isNoSiteCheck: CHECK_BOX_VALUE.no, // You can store the no site check here
    recordsPerPage: GRID_ROWS_PER_PAGE.contractsGrid,
    pageNumber: GRID_ROWS_PER_PAGE.initialIndex,
  },
  selectedComponent: '',
  backClick: false,
  smartSearchData: [],
};
